import React, { Component } from 'react';
import { Popover, PopoverBody } from 'reactstrap';

class ValidacaoItem extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			popoverOpen: false
		};
	}

	toggle = () => {
		if (this.props.value)
			if (this.props.value.includes('inteligente') ||
				this.props.value.includes('estados') ||
				this.props.value.includes('perfilA0'))
				this.setState({ popoverOpen: !this.state.popoverOpen });
	}

	monstrarLabelBasica() {
		if (this.props.value && !this.props.value.includes('basica'))
			return null;

		return (<label className="ecolabel fit cinza">Básica</label>);
	}

	monstrarLabelInteligente() {
		if (this.props.value && !this.props.value.includes('inteligente'))
			return null;

		return (<label className="ecolabel fit azul-ceu">Inteligente</label>);
	}

	monstrarLabelEstados() {
		if (this.props.value && !this.props.value.includes('estados'))
			return null;

		return (<label className="ecolabel fit azul-marinho">Estados</label>);
	}

	monstrarLabelPerfilA0() {
		if (this.props.value && !this.props.value.includes('perfilA0'))
			return null;

		return (<label className="ecolabel fit laranja">Perfil A 0</label>);
	}

	montarButton() {
		var texto = 'Básica';
		var classe = 'ecobtn fit cinza';

		if (this.props.value)
			if (this.props.value.includes('inteligente') ||
				this.props.value.includes('estados') ||
				this.props.value.includes('perfilA0')) {
				texto = 'Várias';
				classe = 'ecobtn fit azul-marinho';
			}

		return (
			<button id={'buttonValidacao-' + this.props.id} className={classe} onClick={this.toggle}>
				{texto}
			</button>);
	}

	render() {
		return (
			<div className="validacoes">
				{this.montarButton()}

				<Popover placement="bottom" isOpen={this.state.popoverOpen} target={'buttonValidacao-' + this.props.id} toggle={this.toggle}>
					<PopoverBody>
						<div className="validacoes-popover">
							<div className="validacoes-realizadas">
								{this.monstrarLabelBasica()}
								{this.monstrarLabelInteligente()}
								{this.monstrarLabelEstados()}
								{this.monstrarLabelPerfilA0()}
							</div>

							<button className="btn btn-link" onClick={this.toggle}>Fechar</button>
						</div>
					</PopoverBody>
				</Popover>
			</div>
		);
	}
}

export default ValidacaoItem;


// WEBPACK FOOTER //
// ./src/Componente/HistoricoResultado/ValidacaoItem.jsx